import { z } from 'zod'
import type { PaginatedResponse } from './common'

export const purchaseTypeSchema = z.enum(['course', 'donation'])
export type PurchaseType = z.infer<typeof purchaseTypeSchema>

export const purchaseStatusSchema = z.enum([
  'created',
  'paid',
  'failed',
  'completed',
])
export type PurchaseStatus = z.infer<typeof purchaseStatusSchema>

export const createPurchaseSchema = z.object({
  purchase_type: purchaseTypeSchema,
  course_id: z.string().optional(),
  campaign_id: z.string().optional(),
  amount_paise: z.number().int().positive(),
  currency: z.string().default('INR'),
  payment_gateway: z.string().default('razorpay'),
  razorpay_order_id: z.string().optional(),
  razorpay_payment_id: z.string().optional(),
  razorpay_signature: z.string().optional(),
  status: purchaseStatusSchema.default('created'),
  access_expires_at: z.string().datetime().optional(),
  purchased_at: z.string().datetime().optional(),
})

export type CreatePurchaseInput = z.infer<typeof createPurchaseSchema>

export type PurchaseResponse = {
  id: string
  legacy_id?: string | null
  user_email: string
  purchase_type: PurchaseType
  course_id?: string | null
  course_domain_id?: string | null
  course_title?: string | null
  campaign_id?: string | null
  amount_paise: number
  currency: string
  payment_gateway?: string | null
  razorpay_order_id?: string | null
  razorpay_payment_id?: string | null
  razorpay_signature?: string | null
  status: PurchaseStatus
  access_expires_at?: string | null
  purchased_at?: string | null
  created_at: string
  updated_at: string
}

export type PurchaseSortBy = 'created_at' | 'amount_paise' | 'purchased_at'

export type PaginatedPurchaseResponse = PaginatedResponse<PurchaseResponse>
